import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import rules from '@/rules';
import utils from '@/utils';
import VueTelInput from 'vue-tel-input'
import VueGeolocation from 'vue-browser-geolocation';
import * as VueGoogleMaps from 'vue2-google-maps'
import VueTheMask from 'vue-the-mask'

Vue.use(VueTheMask)
Vue.use(VueGeolocation);

Vue.use(VueGoogleMaps, {
  load: {
    key:'AIzaSyCnw8PXY_0wQ6hzk4VhdozBH7oEsw2-67s'
  }
})

Vue.use(VueTelInput)

Vue.config.productionTip = false
const axios = require('axios').create({
    baseURL: process.env.NODE_ENV === "production" ? "https://api.olhadela.digital/api" : "http://localhost:8000/",
    withCredentials: true,
});
Vue.prototype.$axios = axios;


Vue.prototype.$rules = rules
Vue.prototype.$utils = utils

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
